import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4960c57a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=4960c57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960c57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4960c57a')) {
      api.createRecord('4960c57a', component.options)
    } else {
      api.reload('4960c57a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4960c57a&scoped=true&", function () {
      api.rerender('4960c57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J0FB2jWlGFqV/JS/comp/SearchFilterTokens.vue"
export default component.exports